import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SharedModule } from './shared/shared.module';
import { LoadingService } from './core/state/loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SharedModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {
  title = 'flexijob-admin-panel';

  /**
   * Wraps the global loading flag in a signal so OnPush change detection
   * picks it up automatically. The `setTimeout` keeps the original UX
   * (defer the overlay by a tick so it doesn't flash during navigation).
   */
  readonly loading = signal(false);
  private timer: ReturnType<typeof setTimeout> | null = null;

  constructor(private loadingService: LoadingService) {
    this.loadingService.loading$.subscribe((value) => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        // Setting a signal automatically triggers OnPush change detection,
        // so the loading overlay updates without an explicit markForCheck().
        this.loading.set(value);
      }, 50);
    });
  }
}
